import { dayjs } from '@trip-ux/common';
import { ValidationErrors } from 'final-form';

const validateEffectiveDate = (effectiveDate, errors, formErrors) => {
   if (effectiveDate.isBefore(new Date())) {
    errors.effectiveDate = formErrors.effectiveDateFutureDtValid;
  }
  if (!effectiveDate.isValid()) {
    errors.effectiveDate = formErrors.effectiveDateInvalid;
  }
  
  return errors;
};

export default function (values, calendarLabels, formErrors): ValidationErrors {
  const errors: ValidationErrors = {};
  if(!values.effectiveDate)
  {
    errors.effectiveDate = formErrors.effectiveDateRequired
  }

  const effectiveDate = dayjs(values.effectiveDate, calendarLabels.dateFormat, true);

  if (values.effectiveDate) {
    validateEffectiveDate(effectiveDate, errors, formErrors);
  }
  return errors;
}